<template>
  <div class="loading" v-if="loading">
    <img src="../assets/loading.gif" />
  </div>
  <div :class="[loading ? 'l-modal__bg' : '']"></div>
  <div class="withdraw" v-if="!isWithdrawal">
    <div style="padding-top: 50px">
      <label>アカウント名 : {{ userInfoStore.userDetail.name }}</label>
      <p>
        一度退会するとアカウントの復元ができません。今までのデータは削除されます。<br />
        ※進行中の案件がある場合など、退会処理の受付ができない場合があります。
      </p>
      <textarea
        v-model="reason"
        class="dialog-text-area"
        required
        placeholder="退会理由"
      ></textarea>
    </div>
    <div class="button-area">
      <common-button
        :data="{
          status: reason ? 0 : 2,
          button: `退会する`,
        }"
        @click="reason ? confirm() : ''"
      ></common-button>
      <common-button
        :data="{
          status: 3,
          button: `キャンセル`,
        }"
        @click="cancel()"
      ></common-button>
    </div>
  </div>
  <comfirm-dialog
    ref="dialog"
    v-model="showDialog"
    :message="message"
    :button="button"
    :sub-message="name"
    @apply="withdrawal()"
  ></comfirm-dialog>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useRouter } from "vue-router";
import CommonButton from "./CommonButton.vue";
import { UserInfoStore } from "../store/UserInfoStore";
import ComfirmDialog from "./ComfirmDialog.vue";
import liff from "@line/liff";

const userInfoStore = UserInfoStore();
const loading = ref(false);

const router = useRouter();
const reason = ref("");
const showDialog = ref(false);
const message = ref("アカウント削除を実行します。\n本当によろしいですか？");
const button = ref("削除");
const dialog = ref<InstanceType<typeof ComfirmDialog>>();
const name = `アカウント名：${userInfoStore.userDetail.name}`;
const isWithdrawal = ref(false);
// 退会処理
async function withdrawal() {
  loading.value = true;
  const result = await userInfoStore.withdrawal(reason.value);

  if (result.result) {
    setTimeout(() => {
      liff.closeWindow();
    }, 1500);
    isWithdrawal.value = true;
    loading.value = false;
  } else {
    loading.value = false;
  }
}
const cancel = () => {
  router.back();
};
function confirm() {
  showDialog.value = true;
  dialog.value?.openDialog();
}
</script>
<style lang="scss" scoped>
@import "../assets/style/_variables.scss";
.l-modal__bg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  position: fixed;
  top: 0;
  left: 0;
  text-align: center;
  z-index: 999;
}
.loading {
  display: flex;
  position: relative;
  justify-content: center;
  top: 50%;
  img {
    width: 10%;
    height: 10%;
  }
}

.withdraw {
  overflow-y: auto;
  text-align: center;
}
.withdraw::-webkit-scrollbar {
  display: none;
}

p {
  font-style: normal;
  font-weight: 300;
  font-size: $FONT_SIZE_M;
  line-height: 21px;
  color: #333333;
  margin: 0;
  padding: 50px 15px;
}
.dialog-text-area {
  width: 300px;
  height: 150px;
  padding-left: 8px;
  padding-top: 8px;
}
textarea {
  overflow-y: auto;
}
.button-area {
  padding-top: 20px;
}
label {
  font-weight: 600;
}
</style>
